// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "@37signals/lexxy";
import "@rails/activestorage";
import "./controllers";

// --- stack npm wiring ---
import { Turbo } from "@hotwired/turbo-rails";
import TurboPower from "turbo_power";

TurboPower.initialize(Turbo.StreamActions);

import Alpine from "alpinejs";
import Sizzle from "sizzle";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";
import persist from "@alpinejs/persist";
import sort from "@alpinejs/sort";
import "alpine-turbo-drive-adapter"; // side-effect only — self-registers via alpine:init

Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(sort);

window.Alpine = Alpine;
window.Sizzle = Sizzle;
window.$ = Sizzle;
Alpine.start();
